import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'
import { Card as AntdCard } from 'antd'
import { Radio } from 'components/patterns'

export const TitleWrapper = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`

export const Title = styled.span`
  font-weight: bold;
  font-size: 20px;
  color: ${themeColor('blackPrimary')};
`

export const ContentWrapper = styled.span`
  font-size: 14px;
  margin-left: 10px;
  color: ${themeColor('blackPrimary')};
`

export const StyledAntdCard = styled(AntdCard)`
  width: 265px;
  height: 150px;
  margin: 6px;
  cursor: pointer;

  &&.ant-card.ant-card-bordered {
    background-color: transparent;
    border: 1px solid ${themeColor('greyPrimary')};
  }

  &:hover {
    &&.ant-card.ant-card-bordered {
      border-color: ${themeColor('bluePrimary')};
    }
  }
`

export const StyledRadio = styled(Radio)``
